import { render } from "./CurDetail.vue?vue&type=template&id=d218804a&scoped=true"
import script from "./CurDetail.vue?vue&type=script&lang=js"
export * from "./CurDetail.vue?vue&type=script&lang=js"

import "./CurDetail.vue?vue&type=style&index=0&id=d218804a&lang=scss"
import "./CurDetail.vue?vue&type=style&index=1&id=d218804a&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d218804a"]])

export default __exports__